<!--进度轴-->
<template>
	<div class="axisBody flexStart">
		<template v-for="(item,index) in dataList">
			<div class="axisItem" :class="{isCheck:nowItem == item}" @click="nowItem=item, $emit('checkItem',nowItem)" @mousemove="showDelete = item" @mouseleave="showDelete = undefined">
				<p :title="item[nameKey]" style="white-space: nowrap;text-overflow: ellipsis;overflow: hidden;width: 100%;">{{item[nameKey]}}</p>
				<img :src="getIconByPath('/axis/axis_delete.png')" class="addIcon deleteIcon" v-show="showDelete == item"
				 @click.stop="$emit('deleteItem',index)" title="删除">
				<img :src="getIconByPath('/axis/axis_edit.png')" title="编辑" class="addIcon editIcon" v-show="showDelete == item" @click.stop="$emit('editItem',item)">
			</div>
			<div class="line"></div>
		</template>
		<!-- <div class="axisItem" @click.stop="$emit('addItem')"> -->
		<div class="axisItem" @click.stop="addItemFun">
			<img :src="getIconByPath('/axis/axis_add.png')" class="addIcon">
		</div>
	</div>
</template>

<script>
	import resourcesStore from '@/cache/resourcesStore.js'
	export default {
		components: {},
		props: {
			dataList: {
				type: Array,
				default(){
					return []
				}
			},
			nameKey: {
				type: String,
				default: 'name'
			},
		},
		data() {
			return {
				showDelete: false,
				nowItem:undefined
			}
		},
		created() {},
		mounted() {},
		destroyed() {},
		computed: {
			getIconByPath(iconPath) {
				return iconPath => {
					return resourcesStore.getters.getResourcesByName(iconPath)
				}
			}
		},
		watch: {},
		methods: {
			setNowItem(item){
				this.nowItem = item
			},
			addItemFun(){
				this.$emit('addItem')
			}

		}
	}
</script>

<style scoped>
	.axisBody {
		padding: 15px;
		overflow-x: auto;
		overflow-y: hidden;
	}

	.axisItem {
		display: inline-block;
		width: .8rem;
		height: .8rem;
		background: white;
		border: .01rem #Ca7800 solid;
		border-radius: 50%;
		position: relative;
		cursor: pointer;
		color:#Ca7800;
	}

	.axisItem:hover,.isCheck {
		background: #Ca7800;
		color: white;
	}

	.axisItem>p {
		height: 100%;
		width: 100%;
		line-height: .8rem;
		text-align: center;
		white-space: nowrap;
		text-overflow: ellipsis;
		overflow: hidden;
	}

	.addIcon {
		width: .2rem;
		height: .2rem;
		padding: .3rem;
	}

	.deleteIcon {
		position: absolute;
		right: 0;
		top: 0;
		padding: 0 0 .1rem .1rem;
	}

	.editIcon {
		position: absolute;
		left: 0;
		top: 0;
		padding: 0 .1rem .1rem 0;
	}

	.deleteIcon:hover,
	.editIcon:hover {
		padding: 0rem;
		width: .3rem;
		height: .3rem;
	}

	.line {
		min-width: .5rem;
		display: inline-block;
		height: .02rem;
		background: #Ca7800;
	}
</style>
